import { createContext, ReactNode, useState } from 'react'

export interface IStepsContextProps {
  currentActive: number | null
  setCurrentActive: (data: number | null) => void
}

// eslint-disable-next-line react-refresh/only-export-components
export const StepsContext = createContext({} as IStepsContextProps)

export const StepsContextProvider = ({ children }: { children: ReactNode }) => {
  const [currentActive, setCurrentActive] = useState<number | null>(null)

  return (
    <StepsContext.Provider
      value={{
        currentActive,
        setCurrentActive,
      }}
    >
      {children}
    </StepsContext.Provider>
  )
}
